import { render } from "./MicrosoftLoginButton.vue?vue&type=template&id=049a0139&ts=true"
import script from "./MicrosoftLoginButton.vue?vue&type=script&lang=ts"
export * from "./MicrosoftLoginButton.vue?vue&type=script&lang=ts"

import "./MicrosoftLoginButton.vue?vue&type=style&index=0&id=049a0139&lang=css"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__